var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1337_7946)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.83349 24.88L14.75 4.24L26.6665 24.88H2.83349Z",
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 2.24
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1337_7946"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTriangle);
export default __webpack_public_path__ + "static/media/icon_triangle.6e2ff063a8a28f9992c28f67359450e9.svg";
export { ForwardRef as ReactComponent };